import React from "react";

import {
  Bone,
  FieldBone,
  InputBone,
  GroupBone,
  RowBone,
  ProjectBone,
  AvatarBone,
} from "./styles";

const Field = () => (
  <FieldBone>
    <Bone width="12rem" />
    <InputBone />
  </FieldBone>
);

// Sigue la silueta real del formulario: grupo Proyecto con el avatar al lado
// de sus campos, y después los grupos de a dos columnas.
export default function FormLoader() {
  return (
    <div style={{ width: "100%" }}>
      <GroupBone>
        <Bone width="9rem" height="1.1rem" />
        <ProjectBone>
          <AvatarBone />
          <RowBone columns={2}>
            <div style={{ gridColumn: "1 / -1" }}>
              <Field />
            </div>
            <Field />
            <Field />
          </RowBone>
        </ProjectBone>
      </GroupBone>

      <GroupBone>
        <Bone width="11rem" height="1.1rem" />
        <RowBone columns={2}>
          <Field />
          <Field />
          <Field />
          <Field />
          <Field />
          <Field />
        </RowBone>
      </GroupBone>

      <GroupBone>
        <Bone width="9rem" height="1.1rem" />
        <RowBone columns={2}>
          <Field />
          <Field />
        </RowBone>
      </GroupBone>
    </div>
  );
}
